var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 24.8889L3.55556 16L6.06222 13.4756L12.4444 19.8578L25.9378 6.36444L28.4444 8.88889M28.4444 0H3.55556C1.58222 0 0 1.58222 0 3.55556V28.4444C0 29.3874 0.374602 30.2918 1.0414 30.9586C1.70819 31.6254 2.61256 32 3.55556 32H28.4444C29.3874 32 30.2918 31.6254 30.9586 30.9586C31.6254 30.2918 32 29.3874 32 28.4444V3.55556C32 1.58222 30.4 0 28.4444 0Z",
    fill: "#3733bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.d13c63d6a2425fbdab7f2ad4480e9ac1.svg";
export { ForwardRef as ReactComponent };